import { SuperModel } from './super-model.model';

export class Color extends SuperModel {
  title: string;
  rgb: string;

  constructor(data: Partial<Color> = {}) {
    super(data);
  }

  get serialised() {
    return {
      title: this.title,
      rgb: this.rgb,
    };
  }
}
